export default __webpack_public_path__ + "static/text-symbol-5a65c2b648c759aa83eb45984efb84a4.svg";